export const AREA_IMAGES = [
  'img_228x140_dak_africa.png',
  'img_228x140_dhs_southlands.png',
  'img_228x140_mk_fantasyland.png',
  'img_228x140_dak_asia.png',
  'img_228x140_dhs_sunsetblvd.png',
  'img_228x140_mk_frontierland.png',
  'img_228x140_dak_dinoland.png',
  'img_228x140_dhs_theaterdistrict.png',
  'img_228x140_mk_libertysquare.png',
  'img_228x140_dak_discoveryisland.png',
  'img_228x140_disneysprings_marketplace.png',
  'img_228x140_mk_mainstreet.png',
  'img_228x140_dak_mainentrance.png',
  'img_228x140_disneysprings_towncenter.png',
  'img_228x140_mk_tomorrowland.png',
  'img_228x140_dak_pandora.png',
  'img_228x140_disneysprings_westside.png',
  'img_228x140_other_blizzardbeach.png',
  'img_228x140_dhs_animationcourtyard.png',
  'img_228x140_epcot_futureworld.png',
  'img_228x140_other_typhoonlagoon.png',
  'img_228x140_dhs_mainentrance.png',
  'img_228x140_epcot_worldshowcase.png'
];

export const IMAGE_BASE_PATH = '/assets/images/';



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/constants/images.constants.ts